(() => {
  const html = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
  let observer;

  // Fade sections in as they scroll into view. Anything already on screen is marked first, so nothing flashes.
  const reveal = (root = document) => {
    const items = [...root.querySelectorAll('[data-lp-reveal]:not(.is-inview)')];
    if (!items.length) return;
    if (reduceMotion || inEditor || !('IntersectionObserver' in window)) {
      items.forEach(item => item.classList.add('is-inview'));
      return;
    }
    const fold = window.innerHeight * 0.94;
    const waiting = items.filter(item => {
      if (item.getBoundingClientRect().top < fold) {
        item.classList.add('is-inview');
        return false;
      }
      return true;
    });
    html.classList.add('lp-js');
    if (!observer) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px' });
    }
    waiting.forEach(item => observer.observe(item));
  };

  // The store's delivery-estimate app adds its product-page message next to every add-to-basket form.
  // It does not belong in the homepage card, so anything it adds there is taken out again.
  const APP_WIDGET = '[class*="delivery-widget"]';
  const keepCardClean = card => {
    if (card.dataset.clean) return;
    card.dataset.clean = 'true';
    let removed = 0;
    const sweep = () => card.querySelectorAll(APP_WIDGET).forEach(node => { node.remove(); removed += 1; });
    sweep();
    if (!('MutationObserver' in window)) return;
    const watcher = new MutationObserver(() => {
      sweep();
      if (removed > 20) watcher.disconnect();
    });
    watcher.observe(card, { childList: true, subtree: true });
  };

  const init = (root = document) => {
    root.querySelectorAll('.lp-buy-card, .lp-ways, .lp-trend').forEach(keepCardClean);
    root.querySelectorAll('.lp-buy-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', () => {
        const button = form.querySelector('button[type="submit"]');
        if (!button) return;
        button.setAttribute('aria-busy', 'true');
        setTimeout(() => button.removeAttribute('aria-busy'), 8000);
      });
    });
    reveal(root);
  };

  // One-time purchase is the selected option every time the page is shown, including when a visitor returns with the back button.
  const resetOptions = () => {
    document.querySelectorAll('.lp-bc-input[data-default]').forEach(input => { input.checked = true; });
    document.querySelectorAll('.lp-buy-form button[aria-busy]').forEach(button => button.removeAttribute('aria-busy'));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  window.addEventListener('pageshow', resetOptions);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
